module.exports = __webpack_public_path__ + "img/defaultImageForSharing-mobile.8db3b3c5.webp";